import { readLiveSensorsAnonymousId } from '../utils/sensorsIdentity';

/** 初始化与身份建立分别记录，身份暂时缺失不能回到首次阶段。 */
interface SensorsReadiness {
  initialized: boolean;
  established: boolean;
}

/** 按窗口隔离浏览器生命周期，不把历史cookie当成初始化证据。 */
const readiness = new WeakMap<Window, SensorsReadiness>();

/** 仅由成功完成神策初始化的Provider标记。 */
export function markSensorsInitialized(): void {
  if (typeof window === 'undefined') return;
  const state = readiness.get(window) ?? { initialized: false, established: false };
  state.initialized = true;
  readiness.set(window, state);
}

/** SDK可选adapter只读取真实初始化完成标记。 */
export function hasSensorsInitialized(): boolean {
  return typeof window !== 'undefined' && readiness.get(window)?.initialized === true;
}

/** 只接受本窗口已初始化 Sensors 的实时匿名ID，不使用缓存或_fpid。 */
export function isSensorsIdentityReady(): boolean {
  if (!hasSensorsInitialized()) return false;
  if (!readLiveSensorsAnonymousId()) return false;
  readiness.get(window)!.established = true;
  return true;
}

/** 后续reset或身份丢失不得重新取得首次身份补齐资格。 */
export function getSensorsIdentityPhase(): 'initial' | 'established' {
  return typeof window !== 'undefined' && readiness.get(window)?.established
    ? 'established'
    : 'initial';
}
